module.exports = __webpack_public_path__ + "img/new-message.0da2d5c3.svg";